import React from 'react';
import { useLocation } from 'react-router-dom';
import useClient from '../../components/util/useClient/useClient';

import statusLogo from './status-logo.svg';

function Header() {
  const client = useClient();
  const location = useLocation();

  const isLinkExpired = (location?.pathname || '').includes('linkExpired');

  const siteURL = client.startsWith('finl')
    ? 'https://www.finishline.com/'
    : 'https://www.jdsports.com/';

  if (isLinkExpired) {
    return null;
  }

  return (
    <div>
      <div className="status-header d-flex flex-row align-items-center justify-content-center">
        <a href={siteURL}>
          <img src={statusLogo} alt="STATUS logo" />
        </a>
      </div>
      <hr className="fl-hr"></hr>
    </div>
  );
}

export default Header;
